module.exports = __webpack_public_path__ + "img/box8-img-1.971d71d3.png";